document.addEventListener('change', async function(event) {
    if (event.target.matches('.option-value-input[type="radio"]')) {
        await existeImgFicha()
    }
});

document.addEventListener("DOMContentLoaded", async () => {
    console.log("iniciando.....")
    await existeImgFicha()
});


async function existeImgFicha() {
    try {
        const skuElement = document.querySelector("span[data-product-sku]");
        if (!skuElement) {
            console.warn("No se encontró el SKU en la página");
            return;
        }

        const currentSku = skuElement.textContent.trim();

        const responseProduct = await fetch(
            `https://sfc2akxvwaaxslp7iknupzh5ua0itbyj.lambda-url.us-east-1.on.aws/api/products/${currentSku}`
        );
        const productJson = await responseProduct.json();

        if (productJson.url_img_ficha_shopify) {
            // Obtener referencias al DOM
            const divFicha = document.getElementById("div-img-ficha-tecnica");
            const imgFicha = document.getElementById("img-ficha-tecnica");
            const btnFicha = document.getElementById("open-ficha-tecnica-modal-btn");
            // Insertar la imagen
            imgFicha.src = productJson.url_img_ficha_shopify;
            // Hacer visible el div
            divFicha.style.display = "inline-block";
            
        } else {
            console.log("El producto no tiene ficha técnica");
        }
    } catch (error) {
        console.error("Error en existeImgFicha:", error);
    }
}